import setCrisisAllocation from './setCrisisAllocation';
import setCrisisCalls from './setCrisisCalls';
import setCrisisCallTeamMembers from './setCrisisCallTeamMembers';

export default {
  setCrisisAllocation,
  setCrisisCalls,
  setCrisisCallTeamMembers,
};
